import React from 'react';
import { QuestionCircleFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import tracker from 'lib/tracker';

interface IProps {
  onClick?: (e: any) => void;
}

const Help: React.FC<IProps> = ({ onClick }) => {
  const onClickHelp = () => {
    onClick && onClick();
    tracker?.reporteWebMenuView('帮助与反馈');
  };
  return (
    <Tooltip placement="bottom" title="帮助与反馈" color="white" overlayInnerStyle={{ color: 'rgba(0, 0, 0, 0.85)' }}>
      <QuestionCircleFilled onClick={onClickHelp} style={{ color: '#999', fontSize: '20px', paddingTop: '2px' }} />
    </Tooltip>
  );
};

export default Help;
